<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item
        v-for="item in pageMeta.breadcrumb"
        :to="{ name: item.name }"
        >{{ item.title }}</el-breadcrumb-item
      >
      <el-breadcrumb-item>查看数据</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      查看数据
    </h1>
    <div class="view-content">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="销售数据" name="1"></el-tab-pane>
        <el-tab-pane label="采购数据" name="3"></el-tab-pane>
        <el-tab-pane label="库存数据" name="2"></el-tab-pane>
      </el-tabs>
      <el-card class="box-card" style="margin-bottom: 20px;">
        <div class="view-filter">
          <el-form :inline="true" :model="filterForm">
            <el-form-item label="月份筛选">
              <el-date-picker
                @change="onSearch"
                v-model="filterForm.date"
                type="month"
                placeholder="选择月"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </el-card>

      <el-card class="box-card">
        <div class="card-content">
          <el-table :data="tableData" ref="multipleTable" style="width: 100%">
            <el-table-column
              type="selection"
              :selectable="checkSelectable"
              width="55"
            >
            </el-table-column>
            <el-table-column prop="login_name" label="账号"> </el-table-column>
            <el-table-column prop="remarks" label="备注"> </el-table-column>
            <el-table-column prop="last_month_log" label="最新数据">
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.last_month_log &&
                      scope.row.last_month_log.create_time
                  "
                >
                  {{ scope.row.last_month_log.create_time }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  v-if="
                    scope.row.last_month_log &&
                      scope.row.last_month_log.create_time
                  "
                  @click.native.prevent="onSee(scope.$index, scope.row)"
                  type="text"
                  size="small"
                >
                  查看数据明细
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="padding-top: 10px">
            <el-button
              type="primary"
              @click="merges"
              :loading="loading"
              v-if="$store.state.funcModuleArray.includes(1901020801)"
              >合并进彩蝶</el-button
            >
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { webscrapAccountList, mergeFiles } from "@/api/index";
import moment from "moment";

export default {
  beforeCreate() {
    this.pageMeta = this.$route.meta;
    this.web_scrap_id = this.$route.params.web_scrap_id;
  },
  name: "",
  data: () => ({
    tableData: [],
    filterForm: {
      date: ""
    },
    loading: false,
    activeName: "1"
  }),
  created() {
    this.filterForm.date = moment();
    this._getList(1);
  },
  methods: {
    _getList() {
      let filterForm = { ...this.filterForm };
      let para = {
        web_scrap_id: this.web_scrap_id
      };
      if (filterForm.date) {
        para.month_date = moment(filterForm.date).format("YYYY-MM") + "-01";
      }
      webscrapAccountList(para).then(res => {
        if (0 === res.status) {
          this.tableData = res.data;
        } else {
          this.tableData = [];
        }
      });
    },

    /*
     * 判断是否可以选择
     * */
    checkSelectable(row) {
      let bool = false;
      if (row.last_month_log && row.last_month_log.web_scrap_log_id) {
        bool = true;
      }
      return bool;
    },
    onSearch() {
      this._getList(1);
    },
    onSee(index, row) {
      let web_scrap_log_id = row.last_month_log.web_scrap_log_id;
      let r = this.$router.resolve({
        name: "webGraspManageMultiAccountWebsiteDetails",
        params: {
          web_scrap_log_id: web_scrap_log_id,
          data_type: this.activeName,
          web_scrap_id: this.web_scrap_id
        }
      });
      window.open(r.href);
    },
    /*
     * 合并进彩蝶
     * */
    merges() {
      console.log(this.$refs.multipleTable.selection);
      let selection = this.$refs.multipleTable.selection;
      let arr = [];
      if (selection.length == 0) {
        this.$message.error("请选择数据");
        return;
      }
      selection.forEach(item => {
        arr.push(item.last_month_log.web_scrap_log_id);
      });

      let para = {
        web_scrap_log_id: arr.join(","),
        data_type: this.activeName
      };
      this.loading = true;
      mergeFiles(para).then(res => {
        this.loading = false;
        if (0 === res.status) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this._getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
::v-deep .el-tabs__header {
  margin-bottom: 0px !important;
}
::v-deep .el-tabs__nav {
  background: #fff;
}
</style>
